// extracted by mini-css-extract-plugin
module.exports = {"bids":"LandingPreHow2_bids__1jx-0","body":"LandingPreHow2_body__lbHvh"};